import { useNewDataValue } from "@/shared/client";
import { useGetReserve, type ReserveInfoResponse } from "@/shared/server";

interface UseNewDataProps {
    newData?: ReserveInfoResponse;
    checkIn: string;
    checkOut?: string;
    checkFake: string;
}

export const useNewData = ({ checkIn, checkOut, checkFake }: UseNewDataProps) => {
    const newData = useNewDataValue();

    const { data: oldData, isLoading } = useGetReserve<ReserveInfoResponse>({
        checkIn,
        checkOut: checkOut ?? checkFake,
    });

    return { data: newData ?? oldData, isLoading };
};
